export default [
  {
    path: "/cbt/hasil-cbt",
    component: () => import("@/pages/cbt/CbtReport.vue"),
  },
  {
    path: "/cbt/hasil-cbt/analisis-soal/:id",
    component: () => import("@/pages/cbt/QuestionAnalyze.vue"),
  },
  {
    path: "/cbt/monitoring",
    component: () => import("@/pages/cbt/CbtMonitoring.vue"),
  },
  {
    path: "/cbt/monitoring/peserta/:id",
    component: () => import("@/pages/cbt/CbtParticipant.vue"),
  },
];
